"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import styled from "styled-components";
import { Button, ButtonVariant, Text, TextColor, TextSize, TextWeight } from "../../components";
import { useMatchBreakpoints } from "../../hooks";
import { extractSize } from "../../utils";

// Styled components for the cart preview
const CartPreviewContainer = styled.div`
  position: relative;
  display: inline-block;
`;
const CartButton = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  tracking-widest;
`;
const CartPreviewContentWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 135%;
  width: 360px;
  background-color: white;
  border: 1px solid #e0e0e0;
  z-index: 20;
  padding: 20px;
  box-shadow: ${({
  theme
}) => theme.shadows.box};
  opacity: ${props => props.$isVisible ? 1 : 0};
  visibility: ${props => props.$isVisible ? "visible" : "hidden"};
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;

  ${({
  theme
}) => theme.mediaQueries.sm} {
    left: 50%;
    right: auto;
    width: 100vw;
    height: calc(100vh - 65px);
    transform: translateX(-50%);
    margin-left: -70px;
    box-shadow: none;
    border: none;
  }
`;
const CartItem = styled.div`
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  padding: 15px 0;

  &:first-child {
    padding-top: 0;
  }
`;
const ItemImage = styled.div`
  flex: 0 0 90px;
  margin-right: 15px;
`;
const ItemDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const PriceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
`;
const CartCounter = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: ${({
  theme
}) => theme.colors.ERROR_500};
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  line-height: 1;
  padding-left: 2px;
`;
export const CartPreviewContent = t0 => {
  const $ = _c(17);
  const {
    icon,
    cart
  } = t0;
  const [isVisible, setIsVisible] = useState(false);
  const {
    isXs,
    isSm,
    isMd
  } = useMatchBreakpoints();
  const isMobile = isXs || isSm || isMd;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsVisible(true);
    t2 = () => setIsVisible(false);
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isMobile) {
    t3 = () => {
      setIsVisible(prev => {
        if (isMobile) {
          console.log("prev", prev);
          document.body.style.overflow = prev ? "overlay" : "hidden";
        }
        return !prev;
      });
    };
    $[2] = isMobile;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== cart) {
    t4 = cart && cart?.productsCount > 0 && <CartCounter><Text text={cart?.productsCount > 99 ? "99+" : cart?.productsCount} color={TextColor.WHITE} fontSize={TextSize.XXS} weight={TextWeight.BOLD} /></CartCounter>;
    $[4] = cart;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text text="Koszyk" color={TextColor.BLACK} fontSize={TextSize.XXS} weight={TextWeight.BOLD} textTransform="uppercase" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== icon || $[8] !== t4) {
    t6 = <Link href="/koszyk"><CartButton className="flex flex-row gap-1 items-center tracking-widest">{icon}{t4}{t5}</CartButton></Link>;
    $[7] = icon;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== cart || $[11] !== isVisible) {
    t7 = cart && cart?.products.length > 0 && <CartPreviewContentWrapper $isVisible={isVisible}><>{cart?.products.map(_temp)}<div className="mt-4">{cart.subtotals?.discounts && cart.subtotals.discounts.amount !== 0 && <PriceContainer><Text text="Rabat" color={TextColor.BLACK} fontSize={TextSize.S} /><Text text={cart.subtotals.discounts.value} color={TextColor.SPECIAL_700} weight={TextWeight.SEMIBOLD} fontSize={TextSize.S} className="bg-green-100" /></PriceContainer>}<PriceContainer><Text text="Dostawa" color={TextColor.BLACK} fontSize={TextSize.S} /><Text text={cart.subtotals.shipping.value ? `${cart.subtotals.shipping.value !== "Za darmo!" ? "od " : ""}${cart.subtotals.shipping.value}` : "od 0,00 z\u0142"} color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.BOLD} /></PriceContainer><PriceContainer><Text text={"\u0141\u0105czna kwota z VAT"} color={TextColor.BLACK} fontSize={TextSize.S} /><Text text={cart.totals.totalIncludingTax.value} color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.BOLD} /></PriceContainer></div><Link href="/koszyk"><Button variant={ButtonVariant.PRIMARY} text="ZOBACZ KOSZYK" className="!w-full" onClick={() => setIsVisible(false)} /></Link></></CartPreviewContentWrapper>;
    $[10] = cart;
    $[11] = isVisible;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t6 || $[15] !== t7) {
    t8 = <CartPreviewContainer onMouseEnter={t1} onMouseLeave={t2} onClick={t3}>{t6}{t7}</CartPreviewContainer>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default CartPreviewContent;
function _temp(product) {
  return <CartItem key={product.idProductAttribute}><ItemImage><div className="bg-gray-100 w-[90px] h-[110px] flex items-center justify-center"><Image src={product.imageUrl.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl")} alt={product.name} width={90} height={110} objectFit="cover" /></div></ItemImage><ItemDetails><div><Link href={`/${product.url}`}><Text text={product.name} color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.MEDIUM} className="mb-1" /></Link><Text text={`Rozmiar: ${extractSize(product.attributesArray || product.attributes)} `} color={TextColor.GRAYSCALE_700} fontSize={TextSize.XS} className="mb-1" /><Text text={`Liczba: ${product.quantity}`} color={TextColor.GRAYSCALE_700} fontSize={TextSize.XS} /></div><div className="flex flex-row gap-2 items-center justify-end"><Text text={product.formattedTotal} color={TextColor.BLACK} fontSize={TextSize.S} weight={TextWeight.BOLD} className="text-right" />{product.totalAmount !== product.totalRegularAmount && <div className="flex flex-col items-end gap-1"><div className="flex gap-1"><Text text={product.formattedTotalRegularPrice} color={TextColor.GRAYSCALE_400} fontSize={TextSize.XS} weight={TextWeight.BOLD} className="text-right" textDecoration="line-through" /></div></div>}</div></ItemDetails></CartItem>;
}